module.exports = __webpack_public_path__ + "static/media/coporation.0965acb9.jpg";